// extracted by mini-css-extract-plugin
export default {"annotationToolbar":"PdfAnnotationSettings_annotationToolbar__umF6T"};